import LoadingAtom from "@/components/loadingAtom/LoadingAtom";
import { useScreenStore } from "@/stores/useScreenStore";
import useVaultFilterStore from "@/stores/zustand/vault/useVaultFilterStore";
import useVaultStore from "@/stores/zustand/vault/useVaultStore";
import { FilterBackgroundName } from "@/types/vault-object-filter-types";
import React from "react";

export const FilteredBackground = () => {
  const isMobileScreen = useScreenStore((state) => state.isMobileScreen);
  const vaultObjectViewerData = useVaultStore(
    (state) => state.vaultObjectViewerData,
  );

  const currentFilter = useVaultFilterStore((state) => state.currentFilter);
  const currentTab = useVaultStore((state) => state.currentTab);
  const canvasStatus = useVaultStore((state) => state.canvasStatus);

  const containerStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    boxShadow: "0 0 8px 4px rgba(0, 0, 0, 0.05) inset",
    borderRadius: vaultObjectViewerData?.embed || isMobileScreen ? "0" : 8,
    background:
      canvasStatus === "idle" || canvasStatus === "loading"
        ? "var(--white)"
        : currentFilter.background.type === FilterBackgroundName.Color
          ? currentFilter.background.hex
          : currentFilter.background.type === FilterBackgroundName.Image
            ? `center / cover no-repeat url(${currentFilter.background.url})`
            : "var(--white)",
    transition: "all 0.3s ease-in-out",
  };

  return (
    <div
      style={{
        width: "auto",
        maxWidth:
          vaultObjectViewerData?.embed || isMobileScreen ? "100vw" : "90vw",
        height:
          vaultObjectViewerData?.embed || isMobileScreen ? "100vh" : "90vh",
        aspectRatio:
          vaultObjectViewerData?.embed || isMobileScreen ? "auto" : "16 / 9",
      }}
    >
      <div
        style={{
          width: `100%`,
          height: "100%",
          padding:
            isMobileScreen && !vaultObjectViewerData?.embed
              ? 12
              : vaultObjectViewerData?.embed
                ? "0"
                : `12px 12px ${currentTab === "show-window" ? "128px" : "64px"} 12px`,
          bottom: 0,
          transition: "height 0.3s ease-in-out, padding 0.3s ease-in-out",
        }}
        className="absolute top-0 bottom-0 left-0"
      >
        {canvasStatus === "loading" && (
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <LoadingAtom width={160} height={160} />
          </div>
        )}
        <div style={containerStyle} />
      </div>
    </div>
  );
};
